import { render, staticRenderFns } from "./AddProductSimple.vue?vue&type=template&id=0d4a8ea6&"
import script from "./AddProductSimple.vue?vue&type=script&lang=js&"
export * from "./AddProductSimple.vue?vue&type=script&lang=js&"
import style0 from "./AddProductSimple.vue?vue&type=style&index=0&id=0d4a8ea6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports